export default __webpack_public_path__ + "static/media/webinar-banner.98e971be.svg";